import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useWarehouseTransferDetail(id) {
  return useSWR(
    !id
      ? null
      : {
          path: `/api/v1/warehouse-transfers/${id}`,
          method: "GET",
        },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useWarehouseTransferDetail;
